import {
    CREATE_PROPERTY_OWNER_FAILURE,
    CREATE_PROPERTY_OWNER_REQUEST,
    CREATE_PROPERTY_OWNER_SUCCESS,
    DELETE_PROPERTY_OWNER_FAILURE,
    DELETE_PROPERTY_OWNER_REQUEST,
    DELETE_PROPERTY_OWNER_SUCCESS,
    FETCH_PROPERTY_OWNER_FAILURE,
    FETCH_PROPERTY_OWNER_REQUEST,
    FETCH_PROPERTY_OWNER_SUCCESS,
    UPDATE_PROPERTY_OWNER_FAILURE,
    UPDATE_PROPERTY_OWNER_REQUEST,
    UPDATE_PROPERTY_OWNER_SUCCESS
} from './types';

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchPropertyOwner = (params) => ({
    type: FETCH_PROPERTY_OWNER_REQUEST,
    payload: params
});

export const fetchPropertyOwnerSuccess = (data) => ({
    type: FETCH_PROPERTY_OWNER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function fetchPropertyOwnerFailure(error) {
    return {
        type: FETCH_PROPERTY_OWNER_FAILURE,
        error
    };
}

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const createPropertyOwner = (params) => ({
    type: CREATE_PROPERTY_OWNER_REQUEST,
    payload: params
});

export const createPropertyOwnerSuccess = (data) => ({
    type: CREATE_PROPERTY_OWNER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function createPropertyOwnerFailure(error) {
    return {
        type: CREATE_PROPERTY_OWNER_FAILURE,
        error
    };
}

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const updatePropertyOwner = (params) => ({
    type: UPDATE_PROPERTY_OWNER_REQUEST,
    payload: params
});

export const updatePropertyOwnerSuccess = (data) => ({
    type: UPDATE_PROPERTY_OWNER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function updatePropertyOwnerFailure(error) {
    return {
        type: UPDATE_PROPERTY_OWNER_FAILURE,
        error
    };
}

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const deletePropertyOwner = (params) => ({
    type: DELETE_PROPERTY_OWNER_REQUEST,
    payload: params
});

export const deletePropertyOwnerSuccess = (data) => ({
    type: DELETE_PROPERTY_OWNER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function deletePropertyOwnerFailure(error) {
    return {
        type: DELETE_PROPERTY_OWNER_FAILURE,
        error
    };
}
